var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.49 6.37V2.178c0-.575-.356-.919-.95-.919H7.743a1.177 1.177 0 0 0-2.28 0H3.55v-.48A.78.78 0 0 0 2.77 0H1.735C.778 0 0 .777 0 1.732v11.536C0 14.223.778 15 1.734 15h3.72a.286.286 0 0 0 0-.571h-3.72c-.641 0-1.163-.52-1.163-1.161 0-.64.522-1.161 1.163-1.161H2.77a.78.78 0 0 0 .779-.778V8.303h2.637l4.716 6.126H6.688a.286.286 0 0 0 0 .571h11.805c.372 0 .996-.13.996-.995V8.058a.29.29 0 0 0 .003-.041L19.49 6.37zM6.602.942a.604.604 0 1 1-.57.797.284.284 0 0 0 0-.39.604.604 0 0 1 .57-.407zM2.98 11.329a.21.21 0 0 1-.208.207H1.734c-.447 0-.855.17-1.163.448V1.732c0-.64.522-1.16 1.163-1.16H2.77a.21.21 0 0 1 .208.206v10.55zm15.94 2.676c0 .293-.062.424-.427.424h-4.789L8.987 8.303h9.931v5.702zm0-6.273h-10.2c-.097 0-.357 0-.462.214-.104.211.05.41.108.485l4.618 5.998h-1.36l-5.003-6.5a.51.51 0 0 0-.436-.197H3.55V6.656h2.374a.286.286 0 0 0 0-.571H3.55V1.83h1.914c.105.418.435.748.854.853v.868a.286.286 0 0 0 .57 0v-.868c.42-.105.75-.435.855-.853h5.84v2.267h-2.388a.452.452 0 0 0-.452.452v1.536H7.311a.286.286 0 0 0 0 .57h6.31a.533.533 0 0 0 .533-.531V1.83h1.078v4.294c0 .293.239.532.532.532h3.154v1.076zm-5.336-3.064v1.417h-2.269V4.668h2.269zm5.335 1.417h-3.115V1.83h2.737c.318 0 .378.122.378.348v3.907z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.433 13.332a.286.286 0 0 0 .286-.285v-.867c.51-.128.89-.59.89-1.139a1.176 1.176 0 0 0-2.35 0c0 .549.379 1.01.889 1.138v.868c0 .158.128.285.285.285zm-.603-2.291a.604.604 0 1 1 1.207.002.604.604 0 0 1-1.207-.002zM13.165 11.128v.868a.286.286 0 1 0 .571 0v-.868c.51-.127.89-.59.89-1.138a1.176 1.176 0 0 0-2.35 0c0 .549.379 1.01.889 1.138zm.286-1.74a.604.604 0 1 1 0 1.207.604.604 0 0 1 0-1.208z",
    fill: "#3CC"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapInfo);
export default __webpack_public_path__ + "static/media/map_info.0a2211e7a20eda87bcc1c04e7595ddbc.svg";
export { ForwardRef as ReactComponent };